import { of } from "rxjs";
import { tap, ignoreElements } from "rxjs/operators";
import { ofType, combineEpics } from "redux-observable";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { createDataSourceOverrideActionTypes, creatingDataSource, createdDataSource, updateDataSourceOverrideActionTypes, updatingDataSource, updatedDataSource } from "./DataSourceCreateContainer.ducks.js";
import DataSourceResource from "../../../../DataSource.resource.js";
import { convertToOverridePostParams } from "../CreateWizard/DataSourceCreateFormSettings.js";
import { DataSourceRouteUtils } from "@ane/exp-data/lib/routes/DataSourceRoute.utils";
const createDataSourceEpic = produceLoadLoadingLoadedEpic({
  filterOnType: createDataSourceOverrideActionTypes.LOAD,
  loadResource: (payload) => {
    let dataSourcePost = convertToOverridePostParams(payload);
    return DataSourceResource.postDataSource(dataSourcePost);
  },
  loadingAction: (payload) => creatingDataSource(),
  loadedAction: (successData, payload, error) => {
    return of(createdDataSource(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const updateDataSourceEpic = produceLoadLoadingLoadedEpic({
  filterOnType: updateDataSourceOverrideActionTypes.LOAD,
  loadResource: (payload) => {
    var _a, _b;
    let dataSourcePost = convertToOverridePostParams(payload);
    return DataSourceResource.putDataSource(dataSourcePost, (_b = (_a = payload.dataSourceItem) == null ? void 0 : _a.data) == null ? void 0 : _b.Version);
  },
  loadingAction: (payload) => updatingDataSource(),
  loadedAction: (successData, payload, error) => {
    return of(updatedDataSource(getCompletedAsyncWrapperObj(successData, error)));
  }
});
const afterCreateDataSource = (action$) => {
  return action$.pipe(
    ofType(createDataSourceOverrideActionTypes.LOADED),
    tap((action) => {
      let postParams = action.payload.createDataSource.data;
      if (!!postParams && !!postParams.OverrideInfo && postParams.OverrideInfo.OverrideFrom.DataSourceName) {
        NavigationService.navigateTo(
          DataSourceRouteUtils.routes.view.getURL({
            id: postParams.OverrideInfo.OverrideFrom.DataSourceName,
            pivot: "override"
          })
        );
      }
    }),
    ignoreElements()
  );
};
const DataSourceCreateEpic = combineEpics(createDataSourceEpic, afterCreateDataSource, updateDataSourceEpic);
export {
  afterCreateDataSource,
  createDataSourceEpic,
  DataSourceCreateEpic as default,
  updateDataSourceEpic
};
//# sourceMappingURL=DataSourceCreateContainer.epic.js.map
